import { useState, useEffect } from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';

import { FaCalendarAlt } from "react-icons/fa";
import { MdAnnouncement } from "react-icons/md";
import { ExamDates } from './TabPages/ExamDates';
import { ExamNotices } from './TabPages/ExamNotices';
import "react-tabs/style/react-tabs.css";

export function CETTabs(props) {
  const [tabIndex, setTabIndex] = useState(0);
  const iconClass = "inline-block w-4 h-4 mr-1" 
  
  useEffect(() => {
    setTabIndex(props.tabId);
  }, [props]);
  
  return (
    <div className="w-full h-full m-2 transition-all ease-in-out border-2">
      <Tabs
        defaultFocus={true}
        selectedIndex={tabIndex}
        onSelect={(index) => setTabIndex(index)}
        id="controlled-tabs"
        className="sm:text-xs lg:text-sm md:text-xs font-normal text-primary-900 bg-transparent"
        selectedTabClassName="border-2 bg-primary-500/10 text-primary-900 border-primary-900 rounded-t-2xl font-extrabold font-stretch"
      >
        <TabList className="flex space-x-1 m-1 border-b-primary-500 border-b-2 round" id="TabList">
          <Tab id="examdates">
            <div className="flex items-center space-x-2">
              <FaCalendarAlt className={`${iconClass} text-purple-500`}/>
              Exam Dates
            </div>
          </Tab>
          <Tab id="examnotices">
            <div className="flex items-center space-x-2">
              <MdAnnouncement className={`${iconClass} text-blue-500`} />
              Exam Notices
            </div>
          </Tab>
        </TabList>
        <TabPanel>
          <div className="flex flex-row">
            <ExamDates />
          </div>
        </TabPanel>
        <TabPanel>
          <div className="flex flex-row">
            <ExamNotices />
          </div>
        </TabPanel>
      </Tabs>
    </div>
  );
}
